import type { SVGProps } from 'react';

const SvgNavigationMarketingAnalytics = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Navigation Marketing Analytics"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M14.47 3.83C8.42 4.58 3.74 9.74 3.74 16c0 6.77 5.49 12.26 12.26 12.26 6.25 0 11.41-4.68 12.17-10.73h-13.7zM.67 16C.67 7.54 7.54.67 16 .67h1.53v13.79h13.79v1.53c0 8.46-6.86 15.33-15.33 15.33S.67 24.46.67 16"
    />
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M20.6 2.21c0-.85.69-1.53 1.53-1.53 5.08 0 9.2 4.12 9.2 9.2 0 .85-.69 1.53-1.53 1.53h-9.2zm3.06 1.72v4.4h4.41a6.13 6.13 0 0 0-4.41-4.4"
    />
  </svg>
);

export default SvgNavigationMarketingAnalytics;
